import { render } from "./DiscardTransactionPopup.vue?vue&type=template&id=72f5cf64&scoped=true"
import script from "./DiscardTransactionPopup.vue?vue&type=script&lang=js"
export * from "./DiscardTransactionPopup.vue?vue&type=script&lang=js"

import "./DiscardTransactionPopup.vue?vue&type=style&index=0&id=72f5cf64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f5cf64"]])

export default __exports__